import React, { useEffect, useRef, useState } from "react";
import Plot from "react-plotly.js";
import scatterData from "../../datas/scatter2dData.json";
import { Box, Button } from "@mui/material";
import Plotly, { update } from "plotly.js";
import {
  addPreClassLabels,
  addProjectClass,
  editPreClassLabel,
  getProject,
  postPreClass,
  updatePreClassLabel,
} from "../../services/projectService";
import { useRecoilState, useRecoilValue } from "recoil";
import { selectedAlgoState } from "../../recoil";
import { useNavigate, useParams } from "react-router-dom";
import CustomButton from "../customComponent/CustomButton";
import { t } from "i18next";
import { COLORS } from "../../styles/GlobalStyles";
import { toast } from "react-toastify";

interface ScatterData {
  x: number;
  y: number;
}

interface GroupedData {
  [key: string]: ScatterData[];
}

const ScatterPlot = ({
  data,
  selectedPointsRef,
}: {
  data: Array<any>;
  selectedPointsRef: React.MutableRefObject<ScatterData[]>;
}) => {
  const handleSelection = async (event: any) => {
    if (event && event.points) {
      const selectedPoints = event.points.map((point: any) => {
        const pointIndex = point.pointIndex; // 선택된 점의 인덱스
        return {
          imageId: data[0].imageId[pointIndex], // 해당 인덱스의 imageId
          x: data[0].x[pointIndex], // 해당 인덱스의 x 좌표
          y: data[0].y[pointIndex], // 해당 인덱스의 y 좌표
          text: data[0].text[pointIndex], // 해당 인덱스의 이미지 경로
        };
      });

      const imageIdArray = selectedPoints.map((point: any) => point.imageId);

      console.log("Selected Points:", imageIdArray);
      selectedPointsRef.current = selectedPoints;
    } else {
      console.log("No points selected");
    }
  };

  return (
    <Plot
      data={data}
      layout={{
        margin: { l: 0, r: 0, t: 0, b: 0 },
        showlegend: true,
        width: 500,
      }}
      onSelected={handleSelection}
    />
  );
};

const Scatter2DChart = () => {
  const navigate = useNavigate();

  const [selectedAlgo, setSelectedAlgo] = useRecoilState(selectedAlgoState);
  const { id } = useParams();
  const selectedPointsRef = useRef<[]>([]);
  const [preClassImages, setPreClassImages] = useState<any[]>([]);
  const [labels, setLabels] = useState<string[]>([]);
  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    setPreClassImages(selectedAlgo.images!);
    setLabels(selectedAlgo.labels!);
  }, []);

  const handleGroupAssignment = async (group: string) => {
    const imageIds = selectedPointsRef.current.map(
      (image: any) => image.imageId
    );

    setPreClassImages((prevImages) =>
      prevImages.map((image) =>
        imageIds.includes(image.id)
          ? { ...image, AILabel: group, recentLabel: group }
          : image
      )
    );
  };

  const updateImages = async () => {
    try {
      await updatePreClassLabel(Number(id), preClassImages); //수정된 사전분류 이미지 저장
      await addPreClassLabels(Number(id), labels);

      toast.success(t("SuccessSaveMsg"));
      navigate(`/project/${id}/analysis`);
    } catch (error) {
      console.error("Failed to update labels and classes:", error);
    }
  };

  const scatterDatas = [
    {
      x: preClassImages.map((img) => img.x), // x 좌표 배열
      y: preClassImages.map((img) => img.y), // y 좌표 배열
      imageId: preClassImages.map((img) => img.id),
      text: preClassImages.map((img) => img.path), // 이미지 경로를 hover로 표시
      mode: "markers",
      marker: {
        size: 10,
        color: preClassImages.map((img) => {
          const labelIndex = labels.indexOf(img.recentLabel);
          return labelIndex !== -1
            ? COLORS[labelIndex % COLORS.length]
            : "black";
        }),
      },
    },
  ];

  const handleEdit = () => {
    console.log("edit");
    setIsEdit(true);
  };

  const handleCancel = () => {
    setIsEdit(false);
    setPreClassImages(selectedAlgo.images!);
  };

  return (
    <Box sx={{ width: "fit-content", height: "100%" }}>
      <Box sx={{ height: "100%", display: "flex", alignItems: "center" }}>
        <ScatterPlot
          data={scatterDatas}
          selectedPointsRef={selectedPointsRef}
        />
        {isEdit ? (
          <Box
            sx={{
              mt: 2,
              ml: 2,
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            {labels.map((label) => (
              <Button
                variant="contained"
                onClick={() => handleGroupAssignment(label)}
                sx={{ mb: 1 }}
              >
                {label}
              </Button>
            ))}
          </Box>
        ) : null}
      </Box>
      <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
        {isEdit ? (
          <>
            <CustomButton
              text={t("Confirm")}
              variant="contained"
              onClick={updateImages}
            />
            <Button onClick={handleCancel} sx={{ ml: 1 }}>
              {t("Cancel")}
            </Button>
          </>
        ) : (
          <Box sx={{ display: "flex", gap: 1 }}>
            <CustomButton
              text={t("AlgorithmKr") + " " + t("Edit")}
              variant="contained"
              onClick={handleEdit}
            />
            <CustomButton
              text={t("Confirm")}
              variant="contained"
              onClick={updateImages}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default Scatter2DChart;
